export default "__VITE_ASSET__5aa24f40__"